/* product.js — variant picker, gallery, qty. Loaded only on product pages. */
(function () {
  'use strict';
  var theme = window.theme || {};
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var variants = [];
  var media = [];
  try { variants = JSON.parse(section.querySelector('[data-variants]').textContent); } catch (e) {}
  try { media = JSON.parse(section.querySelector('[data-product-media]').textContent); } catch (e) {}
  var variantMedia = {};
  try {
    JSON.parse(section.querySelector('[data-variant-media]').textContent).forEach(function (x) { variantMedia[x.v] = x.m; });
  } catch (e) {}

  var form = section.querySelector('[data-product-form]');
  var idInput = section.querySelector('[data-variant-id]');
  var priceCurrent = section.querySelector('[data-price-current]');
  var priceCompare = section.querySelector('[data-price-compare]');
  // The struck amount sits in its own element so a set's "Separately" label survives updates.
  var priceCompareAmt = section.querySelector('[data-price-compare-amount]') || priceCompare;
  var priceSave = section.querySelector('[data-price-save]');
  var addBtn = section.querySelector('[data-add-btn]');
  var addText = section.querySelector('[data-add-text]');
  var addPrice = section.querySelector('[data-add-price]');
  var qtyInput = section.querySelector('[data-qty-input]');
  var stickyBar = section.querySelector('[data-pdp-sticky]');
  var stickyPrice = section.querySelector('[data-sticky-price]');
  var stickyCompare = section.querySelector('[data-sticky-compare]');
  var stickySave = section.querySelector('[data-sticky-save]');
  var stickyBtn = section.querySelector('[data-sticky-add]');
  var stickyText = section.querySelector('[data-sticky-add-text]');
  var ADD_LABEL = (theme.strings && theme.strings.addToCart) || 'Add to cart';
  var SOLD_LABEL = (theme.strings && theme.strings.soldOut) || 'Sold out';
  // Prices come from the variant only. The theme used to compute a discount here
  // from data-sale-percent, mirroring a Shopify automatic discount Liquid could
  // not see; that discount is gone (2026-08-14) and the sale lives in real
  // compare-at prices, so there is nothing left to compute.
  // Percentages are floored to match Liquid — see savePct below.
  function savePct(v) { return Math.floor((1 - v.price / v.compare_at_price) * 100); }
  // "Save $X (Y%)" on everything, sets included (Sep 2026 sale system); the
  // wording comes from the locale via data attributes, like Liquid's first paint.
  // The short "−Y%" form is the per-size chip and the sticky bar.
  var SAVE_TEXT = section.getAttribute('data-save-text') || 'Save [amount] ([pct]%)';
  var CHIP_TEXT = section.getAttribute('data-chip-text') || '−[pct]%';
  // 'sale' | 'set' | 'none' from snippets/product-offer. Chips show only in a sale.
  var offerKind = section.getAttribute('data-offer-kind') || 'none';
  function saveText(v) {
    return SAVE_TEXT.replace('[amount]', formatMoney(v.compare_at_price - v.price)).replace('[pct]', savePct(v));
  }
  function chipText(v) { return CHIP_TEXT.replace('[pct]', savePct(v)); }
  var AMOUNT_TEXT = section.getAttribute('data-amount-text') || 'Save [amount]';
  // "In this set" panel data: per-size one-by-one total, piece prices and the
  // hung footprint, rendered by Liquid from snippets/bundle-sizes.
  // Per-size value lines ("4× the art · 2.1× the price"): Liquid ranks the
  // sizes, reads each one's area from its name and picks the base (smallest
  // area) and best (lowest price per unit of area); it renders the first
  // paint from each size's cheapest variant. This re-renders for the frame
  // actually selected, so the ratio always uses the price on the row.
  // Absent on sets and when the section switch is off.
  var sizeInfo = null;
  var sizeJson = section.querySelector('[data-size-areas]');
  if (sizeJson) { try { sizeInfo = JSON.parse(sizeJson.textContent); } catch (e) { sizeInfo = null; } }
  var pricePct = section.querySelector('[data-price-pct]');
  var STR_LINE = section.getAttribute('data-value-line-text') || '[art]× bigger';
  var STR_MORE = section.getAttribute('data-value-more-text') || '[pct]% more value';
  var STR_PCT = section.getAttribute('data-value-pct-text') || '[pct]% less per inch';
  var STR_BASE = section.getAttribute('data-value-base-text') || 'Starting size';
  // 4.0 prints as "4", 2.09 as "2.1" — the × sign is in the locale string. The
  // number on the page is the number the shopper can check against the two
  // prices, never rounded to "2×".
  function timesLabel(n) { var t = n.toFixed(1); return t.slice(-2) === '.0' ? t.slice(0, -2) : t; }
  // Price of the base size in the current frame; the cheapest variant of that
  // size when the combination does not exist.
  function basePrice(opts, pos) {
    var combo = opts.slice(); combo[pos] = sizeInfo.base;
    var b = findVariant(combo);
    if (b) return b.price;
    var min = 0;
    variants.forEach(function (x) { if (x.options[pos] === sizeInfo.base && (!min || x.price < min)) min = x.price; });
    return min;
  }
  // "% less per inch" for `size` at `price` against the base size in the
  // current frame: an integer (may be <= 0 on an odd ladder), or null when
  // there is nothing to compare (the base size, or a size that did not parse).
  function pctFor(size, price, opts, pos) {
    if (!sizeInfo) return null;
    var area = sizeInfo.areas[size], baseArea = sizeInfo.areas[sizeInfo.base];
    if (!area || !baseArea || area === baseArea) return null;
    var bp = basePrice(opts, pos);
    if (!bp) return null;
    return Math.round(100 - (price / area) / (bp / baseArea) * 100);
  }
  function showPct(el, tpl, pct) {
    if (!el) return;
    if (pct !== null && pct > 0) { el.textContent = tpl.replace('[pct]', pct); el.hidden = false; }
    else { el.hidden = true; }
  }
  // Writes the row line ("1.8× bigger", or "Starting size") for `size`.
  function fillValue(el, size) {
    if (!sizeInfo || !el) return;
    var area = sizeInfo.areas[size], baseArea = sizeInfo.areas[sizeInfo.base];
    if (!area || !baseArea) { el.textContent = ''; return; }
    el.textContent = area === baseArea ? STR_BASE : STR_LINE.replace('[art]', timesLabel(area / baseArea));
  }
  var bundleSizes = null;
  var bundleJson = section.querySelector('[data-bundle-sizes]');
  if (bundleJson) { try { bundleSizes = JSON.parse(bundleJson.textContent); } catch (e) { bundleSizes = null; } }
  function updateBundlePanel(opts, v) {
    if (!bundleSizes) return;
    var sizeInput = section.querySelector('.size-table [data-option-input]');
    if (!sizeInput) return;
    var pos = parseInt(sizeInput.getAttribute('data-option-position'), 10) - 1;
    var size = opts[pos];
    var d = bundleSizes[size];
    var value = section.querySelector('[data-bundle-value]');
    var wall = section.querySelector('[data-bundle-wall]');
    if (!d) { if (value) value.hidden = true; if (wall) wall.hidden = true; return; }
    section.querySelectorAll('[data-bundle-piece]').forEach(function (el) {
      var p = d.pieces[parseInt(el.getAttribute('data-bundle-piece'), 10)];
      if (p > 0) { el.textContent = (el.getAttribute('data-bundle-piece-prefix') || '') + ' ' + formatMoney(p); el.hidden = false; }
      else { el.hidden = true; }
    });
    if (value) {
      var sep = value.querySelector('[data-bundle-sep]');
      var set = value.querySelector('[data-bundle-set]');
      if (d.sum > 0 && v) { if (sep) sep.textContent = formatMoney(d.sum); if (set) set.textContent = formatMoney(v.price); value.hidden = false; }
      else { value.hidden = true; }
    }
    if (wall) {
      var txt = wall.querySelector('[data-bundle-wall-text]');
      if (d.w > 0 && txt) {
        var tpl = (theme.strings && theme.strings.bundleWall) || 'Hangs about [w]\u2033 wide \u00d7 [h]\u2033 tall at [size], with 3\u2033 between frames.';
        txt.textContent = tpl.replace('[w]', d.w).replace('[h]', d.h).replace('[size]', size);
        wall.hidden = false;
      } else { wall.hidden = true; }
    }
  }

  /* ---- money ---- */
  function formatMoney(cents) {
    var fmt = theme.moneyFormat || '${{amount}}';
    function fwd(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = fwd(cents, 0); break;
      case 'amount_with_comma_separator': val = fwd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fwd(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = fwd(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': val = fwd(cents, 0, ' ', ''); break;
      default: val = fwd(cents, 2);
    }
    // Whole-dollar prices drop ".00", matching Liquid's money_without_trailing_zeros.
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val.replace(/[.,]00$/, ''));
  }

  function selectedOptions() {
    var opts = [];
    form.querySelectorAll('[data-option-input]:checked').forEach(function (i) {
      opts[parseInt(i.getAttribute('data-option-position'), 10) - 1] = i.value;
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.filter(function (v) {
      return v.options.every(function (o, idx) { return o === opts[idx]; });
    })[0];
  }

  /* ---- gallery: scroll-snap slide track + thumbnail rail ---- */
  var track = section.querySelector('[data-gallery-track]');
  var slides = toArray(section.querySelectorAll('[data-gallery-slide]'));
  var thumbsRail = section.querySelector('[data-thumbs]');
  var thumbBtns = toArray(section.querySelectorAll('[data-gallery-thumb]'));
  var galleryPrev = section.querySelector('[data-gallery-prev]');
  var galleryNext = section.querySelector('[data-gallery-next]');
  var galleryIndexEl = section.querySelector('[data-gallery-index]');
  var thumbsPrev = section.querySelector('[data-thumbs-prev]');
  var thumbsNext = section.querySelector('[data-thumbs-next]');
  var galleryIndex = 0;
  var uspSync = null; // assigned below when the USP overlay exists
  var videoSync = null; // assigned below when the gallery holds a video
  // Picture slides, in lightbox order (data-lb). Videos are slides too but
  // never open the zoom lightbox, so lightbox index != slide index.
  var lbSlides = slides.filter(function (s) { return s.hasAttribute('data-lb'); });

  function toArray(list) { return Array.prototype.slice.call(list); }

  function scrollIntoRail(el) {
    if (!thumbsRail || !el) return;
    var rail = thumbsRail.getBoundingClientRect();
    var box = el.getBoundingClientRect();
    if (box.left < rail.left) thumbsRail.scrollBy({ left: box.left - rail.left - 10, behavior: 'smooth' });
    else if (box.right > rail.right) thumbsRail.scrollBy({ left: box.right - rail.right + 10, behavior: 'smooth' });
  }

  function syncRailArrows() {
    if (!thumbsRail || !thumbsPrev || !thumbsNext) return;
    var max = thumbsRail.scrollWidth - thumbsRail.clientWidth;
    thumbsPrev.hidden = thumbsRail.scrollLeft <= 1;
    thumbsNext.hidden = thumbsRail.scrollLeft >= max - 1;
  }

  // Reflects the slide the track is parked on; does not move the track itself.
  function markSlide(i) {
    if (i < 0 || i >= slides.length) return;
    galleryIndex = i;
    thumbBtns.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
    if (galleryIndexEl) galleryIndexEl.textContent = i + 1;
    if (galleryPrev) galleryPrev.disabled = i === 0;
    if (galleryNext) galleryNext.disabled = i === slides.length - 1;
    scrollIntoRail(thumbBtns[i]);
    if (uspSync) uspSync(i);
    if (videoSync) videoSync(i);
  }

  function goToSlide(i) {
    if (!track || i < 0 || i >= slides.length) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    markSlide(i);
  }

  function slideIndexForMedia(mediaId) {
    for (var i = 0; i < slides.length; i++) {
      if (parseInt(slides[i].getAttribute('data-media-id'), 10) === mediaId) return i;
    }
    return -1;
  }

  function updateSizePrices(opts) {
    var rows = section.querySelectorAll('[data-size-price]');
    if (!rows.length) return;
    // size option position = position of the input inside .size-table
    var sizeInput = section.querySelector('.size-table [data-option-input]');
    if (!sizeInput) return;
    var pos = parseInt(sizeInput.getAttribute('data-option-position'), 10) - 1;
    rows.forEach(function (el) {
      var combo = opts.slice();
      combo[pos] = el.getAttribute('data-size-price');
      var v = findVariant(combo);
      var label = el.closest('label');
      var save = label ? label.querySelector('[data-size-save]') : null;
      var val = label ? label.querySelector('[data-size-value]') : null;
      var pctEl = label ? label.querySelector('[data-size-pct]') : null;
      var wasEl = label ? label.querySelector('[data-size-was]') : null;
      var amtEl = label ? label.querySelector('[data-size-amount]') : null;
      if (!v) { el.textContent = ''; if (save) save.hidden = true; if (val) val.textContent = ''; if (pctEl) pctEl.hidden = true; if (wasEl) wasEl.hidden = true; if (amtEl) amtEl.hidden = true; return; }
      var vHasCompare = v.compare_at_price && v.compare_at_price > v.price;
      var now = v.price;
      el.textContent = formatMoney(now);
      var rowSize = el.getAttribute('data-size-price');
      if (val) fillValue(val, rowSize);
      if (pctEl) showPct(pctEl, STR_PCT, pctFor(rowSize, now, opts, pos));
      var was = vHasCompare ? v.compare_at_price : 0;
      if (save) {
        if (offerKind === 'sale' && was > now) { save.textContent = chipText(v); save.hidden = false; }
        else { save.hidden = true; }
      }
      // Struck compare-at and the green dollar saving: on every size whose variant
      // has a compare-at above its price (sale items, and sets vs. "Separately").
      if (wasEl) {
        if (was > now) { wasEl.textContent = formatMoney(was); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (amtEl) {
        if (was > now) { amtEl.textContent = AMOUNT_TEXT.replace('[amount]', formatMoney(was - now)); amtEl.hidden = false; }
        else { amtEl.hidden = true; }
      }
    });
  }

  function update(followMedia) {
    var opts = selectedOptions();
    form.querySelectorAll('[data-option-input]').forEach(function (i) {
      var label = i.closest('label');
      if (label) label.classList.toggle('is-selected', i.checked);
    });
    form.querySelectorAll('[data-option-label]').forEach(function (el) {
      el.textContent = opts[parseInt(el.getAttribute('data-option-label'), 10)] || '';
    });
    var v = findVariant(opts);
    updateSizePrices(opts);
    if (!v) {
      addBtn.disabled = true; addText.textContent = SOLD_LABEL; addPrice.textContent = '';
      if (stickyBtn) { stickyBtn.disabled = true; stickyText.textContent = SOLD_LABEL; }
      return;
    }
    idInput.value = v.id;
    var qty = parseInt(qtyInput.value, 10) || 1;
    var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
    var nowPrice = v.price;
    priceCurrent.textContent = formatMoney(nowPrice);
    addPrice.textContent = formatMoney(nowPrice * qty);
    if (stickyPrice) stickyPrice.textContent = formatMoney(nowPrice);
    if (stickyCompare) {
      if (hasCompare) { stickyCompare.textContent = formatMoney(v.compare_at_price); stickyCompare.hidden = false; }
      else { stickyCompare.hidden = true; }
    }
    if (stickySave) {
      if (hasCompare) { stickySave.textContent = chipText(v); stickySave.hidden = false; }
      else { stickySave.hidden = true; }
    }
    if (hasCompare) {
      priceCompareAmt.textContent = formatMoney(v.compare_at_price); priceCompare.hidden = false;
      priceSave.textContent = saveText(v); priceSave.hidden = false;
    } else { priceCompare.hidden = true; priceSave.hidden = true; }
    updateBundlePanel(opts, v);
    if (pricePct && sizeInfo) {
      var sizeEl = section.querySelector('.size-table [data-option-input]');
      var sizePos = sizeEl ? parseInt(sizeEl.getAttribute('data-option-position'), 10) - 1 : -1;
      // Same per-inch figure as the row, worded "more value" (merchant's call).
      showPct(pricePct, STR_MORE, sizePos > -1 ? pctFor(opts[sizePos], v.price, opts, sizePos) : null);
    }
    addBtn.disabled = !v.available;
    addText.textContent = v.available ? ADD_LABEL : SOLD_LABEL;
    if (stickyBtn) { stickyBtn.disabled = !v.available; stickyText.textContent = v.available ? ADD_LABEL : SOLD_LABEL; }
    if (window.history && history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    // The gallery only follows the variant once the shopper picks a size or
    // frame. On first paint (and on qty changes) it stays on image 1, so the
    // hero shot is what greets them instead of a variant close-up.
    if (!followMedia) return;
    // Every size × frame variant carries its own mockup, so the variant's
    // featured media is the only source of truth for which slide to show. A
    // variant with no media leaves the gallery where it is. (An alt-text
    // fallback that matched the size string lived here 2026-09-02..07; it
    // landed on the first slide of that size in whatever frame, so a black
    // frame could show a wood mockup. Do not bring it back — and do not add a
    // "Shown: <frame>" caption that echoes the swatch instead of the image.)
    var mid = variantMedia[v.id];
    if (!mid) return;
    var idx = slideIndexForMedia(mid);
    if (idx > -1) goToSlide(idx);
  }

  // Only a FRAME change moves the gallery. Every size of a colour shares one
  // mockup (the largest print) since 2026-09-07, so a size change has nothing
  // new to show and should leave the shopper on whatever image they were
  // looking at — the studio shots are the better pictures anyway.
  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-option-input]')) return;
    update(!!e.target.closest('.frame-swatches'));
  });

  /* qty */
  form.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var val = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = plus ? val + 1 : Math.max(1, val - 1);
    update();
  });
  qtyInput.addEventListener('change', update);

  /* gallery wiring */
  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { goToSlide(i); });
  });
  if (galleryPrev) galleryPrev.addEventListener('click', function () { goToSlide(galleryIndex - 1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { goToSlide(galleryIndex + 1); });

  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (!track.clientWidth) return;
        markSlide(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    }, { passive: true });
    // Keep the parked slide parked when the stage is resized (orientation change).
    if ('ResizeObserver' in window) {
      var lastWidth = track.clientWidth;
      new ResizeObserver(function () {
        if (track.clientWidth === lastWidth) return;
        lastWidth = track.clientWidth;
        track.scrollLeft = galleryIndex * track.clientWidth;
      }).observe(track);
    }
    // Arrow keys step the gallery when it has focus.
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(galleryIndex - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(galleryIndex + 1); }
    });
  }

  if (thumbsRail) {
    var railStep = function (dir) {
      thumbsRail.scrollBy({ left: dir * thumbsRail.clientWidth * 0.8, behavior: 'smooth' });
    };
    if (thumbsPrev) thumbsPrev.addEventListener('click', function () { railStep(-1); });
    if (thumbsNext) thumbsNext.addEventListener('click', function () { railStep(1); });
    thumbsRail.addEventListener('scroll', syncRailArrows, { passive: true });
    window.addEventListener('resize', syncRailArrows);
    syncRailArrows();
  }

  /* ---- gallery videos: the one on screen plays, muted and looping, like a
     moving photo; every other one is paused. preload="none" in the markup, so
     a video costs nothing until its slide is reached. The button (and a tap
     on the video) pauses/resumes; a shopper's pause sticks for that video.
     Reduced-motion shoppers get the poster and press play themselves. ---- */
  var videoSlides = slides.filter(function (s) { return s.querySelector('video'); });
  if (videoSlides.length) {
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var galleryOnScreen = true;
    var setPlaying = function (s, on) {
      s.classList.toggle('is-playing', on);
      var btn = s.querySelector('[data-video-toggle]');
      if (btn) btn.setAttribute('aria-label', btn.getAttribute(on ? 'data-label-pause' : 'data-label-play'));
    };
    var playVideo = function (s) {
      var v = s.querySelector('video');
      v.muted = true; // the property, not just the attribute, is what autoplay policy checks
      var p = v.play();
      if (p && p.catch) p.catch(function () { setPlaying(s, false); });
    };
    videoSlides.forEach(function (s) {
      var v = s.querySelector('video');
      v.addEventListener('play', function () { setPlaying(s, true); });
      v.addEventListener('pause', function () { setPlaying(s, false); });
      var toggle = function () {
        if (v.paused) { s.removeAttribute('data-user-paused'); playVideo(s); }
        else { s.setAttribute('data-user-paused', ''); v.pause(); }
      };
      v.addEventListener('click', toggle);
      var btn = s.querySelector('[data-video-toggle]');
      if (btn) btn.addEventListener('click', toggle);
    });
    videoSync = function (i) {
      videoSlides.forEach(function (s) {
        var v = s.querySelector('video');
        if (s === slides[i] && galleryOnScreen && !reduceMotion && !s.hasAttribute('data-user-paused')) playVideo(s);
        else if (!v.paused) v.pause();
      });
    };
    // Scrolled past the gallery: stop looping a video nobody can see.
    if (track && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        galleryOnScreen = entries[0].isIntersecting;
        videoSync(galleryIndex);
      }, { threshold: 0.25 }).observe(track);
    }
    // Chrome rejects play() in a background tab ("video-only background media
    // was paused to save power"); pick the video back up when the tab returns.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) videoSync(galleryIndex);
    });
  }

  markSlide(0);

  /* ---- Full-screen lightbox: wheel/pinch zoom, drag pan, swipe navigate ---- */
  var lb = section.querySelector('[data-lightbox]');
  if (lb && media.length) {
    var lbStage = lb.querySelector('[data-lb-stage]');
    var lbImg = lb.querySelector('[data-lb-img]');
    var lbIndexEl = lb.querySelector('[data-lb-index]');
    var lbPrev = lb.querySelector('[data-lb-prev]');
    var lbNext = lb.querySelector('[data-lb-next]');
    var lbCloseBtn = lb.querySelector('[data-lb-close]');
    var lbHint = lb.querySelector('[data-lb-hint]');
    var lbThumbs = toArray(lb.querySelectorAll('[data-lb-thumb]'));
    var lbIndex = 0, lbScale = 1, lbX = 0, lbY = 0;
    var lastFocus = null, hintHidden = false;

    function lbApply() {
      lbImg.style.transform = 'translate(' + lbX + 'px,' + lbY + 'px) scale(' + lbScale + ')';
      lbImg.classList.toggle('is-zoomed', lbScale > 1.01);
    }
    function lbClampPan() {
      var maxX = Math.max(0, (lbImg.clientWidth * lbScale - lbStage.clientWidth) / 2);
      var maxY = Math.max(0, (lbImg.clientHeight * lbScale - lbStage.clientHeight) / 2);
      lbX = Math.min(maxX, Math.max(-maxX, lbX));
      lbY = Math.min(maxY, Math.max(-maxY, lbY));
    }
    function lbReset() { lbScale = 1; lbX = 0; lbY = 0; lbApply(); }
    // The 2400px zoom variants are fetched off-screen and swapped in once
    // ready, so navigating always paints instantly from an image the browser
    // already has instead of blocking on a fresh network fetch.
    var lbBig = {};
    function lbWarm(i) {
      if (i < 0 || i >= media.length) return null;
      var src = media[i].big || media[i].url;
      var im = lbBig[src];
      if (!im) { im = new Image(); im.src = src; lbBig[src] = im; }
      return im;
    }
    function lbShow(i) {
      if (i < 0 || i >= media.length) return;
      lbIndex = i;
      lbReset();
      var big = media[i].big || media[i].url;
      var warm = lbWarm(i);
      if (warm.complete && warm.naturalWidth) {
        lbImg.src = big;
      } else {
        // paint what the main gallery already decoded for this slide (or the
        // preloaded 1400px url), then upgrade in place when the big one lands
        var slideImg = lbSlides[i] && lbSlides[i].querySelector('.pdp__main-img');
        lbImg.src = (slideImg && (slideImg.currentSrc || slideImg.src)) || media[i].url;
        warm.addEventListener('load', function () {
          if (lbIndex === i && !lb.hidden) lbImg.src = big;
        }, { once: true });
      }
      lbImg.alt = media[i].alt || '';
      lbWarm(i + 1);
      lbWarm(i - 1);
      if (lbIndexEl) lbIndexEl.textContent = i + 1;
      if (lbPrev) lbPrev.disabled = i === 0;
      if (lbNext) lbNext.disabled = i === media.length - 1;
      lbThumbs.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      if (lbThumbs[i] && lbThumbs[i].scrollIntoView) lbThumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function hideHint() {
      if (hintHidden || !lbHint) return;
      hintHidden = true;
      lbHint.classList.add('is-hidden');
    }
    function lbOpen(i) {
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.body.classList.add('lb-open');
      lbShow(i);
      if (lbCloseBtn) lbCloseBtn.focus();
    }
    function lbShut() {
      lb.hidden = true;
      document.body.classList.remove('lb-open');
      goToSlide(slides.indexOf(lbSlides[lbIndex])); // main gallery follows where the shopper left off
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    // Zoom keeping the point under the cursor/pinch midpoint fixed.
    function zoomTo(newScale, cx, cy) {
      newScale = Math.min(4, Math.max(1, newScale));
      var r = lbStage.getBoundingClientRect();
      var px = cx - r.left - r.width / 2;
      var py = cy - r.top - r.height / 2;
      var k = newScale / lbScale;
      lbX = px - (px - lbX) * k;
      lbY = py - (py - lbY) * k;
      lbScale = newScale;
      if (lbScale <= 1.001) { lbX = 0; lbY = 0; }
      lbClampPan();
      lbApply();
      hideHint();
    }

    lbStage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomTo(lbScale * (e.deltaY < 0 ? 1.18 : 1 / 1.18), e.clientX, e.clientY);
    }, { passive: false });

    lbStage.addEventListener('dblclick', function (e) {
      e.preventDefault();
      zoomTo(lbScale > 1.01 ? 1 : 2.5, e.clientX, e.clientY);
    });

    var lbPts = {};
    var pinchD0 = 0, pinchS0 = 1, lbMoved = false;
    var downX = 0, downY = 0, imgX0 = 0, imgY0 = 0;
    lbStage.addEventListener('pointerdown', function (e) {
      lbStage.setPointerCapture(e.pointerId);
      lbPts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(lbPts);
      if (ids.length === 1) {
        lbMoved = false;
        downX = e.clientX; downY = e.clientY; imgX0 = lbX; imgY0 = lbY;
        if (lbScale > 1.01) lbImg.classList.add('is-dragging');
      } else if (ids.length === 2) {
        var a = lbPts[ids[0]], b = lbPts[ids[1]];
        pinchD0 = Math.hypot(a.x - b.x, a.y - b.y);
        pinchS0 = lbScale;
      }
    });
    lbStage.addEventListener('pointermove', function (e) {
      if (!lbPts[e.pointerId]) return;
      lbPts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(lbPts);
      if (ids.length === 2) {
        var a = lbPts[ids[0]], b = lbPts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        if (pinchD0 > 0) zoomTo(pinchS0 * d / pinchD0, (a.x + b.x) / 2, (a.y + b.y) / 2);
        lbMoved = true;
      } else if (ids.length === 1) {
        var dx = e.clientX - downX, dy = e.clientY - downY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) lbMoved = true;
        if (lbScale > 1.01) {
          lbX = imgX0 + dx; lbY = imgY0 + dy;
          lbClampPan();
          lbApply();
        }
      }
    });
    function lbPointerEnd(e) {
      if (!lbPts[e.pointerId]) return;
      delete lbPts[e.pointerId];
      lbImg.classList.remove('is-dragging');
      var remaining = Object.keys(lbPts);
      if (remaining.length === 1) {
        // pinch ended with one finger down — rebase the pan so it doesn't jump
        pinchD0 = 0;
        var p = lbPts[remaining[0]];
        downX = p.x; downY = p.y; imgX0 = lbX; imgY0 = lbY;
        lbMoved = true;
        return;
      }
      if (remaining.length) return;
      var dx = e.clientX - downX, dy = e.clientY - downY;
      if (lbScale <= 1.01 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        lbShow(lbIndex + (dx < 0 ? 1 : -1));
        hideHint();
      } else if (!lbMoved && e.target === lbStage) {
        lbShut(); // tap/click on the backdrop closes
      }
    }
    lbStage.addEventListener('pointerup', lbPointerEnd);
    lbStage.addEventListener('pointercancel', function (e) {
      delete lbPts[e.pointerId];
      lbImg.classList.remove('is-dragging');
      pinchD0 = 0;
    });

    if (lbPrev) lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
    if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbShut);
    lbThumbs.forEach(function (b, n) {
      b.addEventListener('click', function () { lbShow(n); });
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbShut();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
    lbSlides.forEach(function (s, n) {
      var img = s.querySelector('.pdp__main-img');
      if (img) img.addEventListener('click', function () { lbOpen(n); });
    });
    // Keyboard path (the expand button was removed): Enter on the focused track
    if (track) track.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var n = lbSlides.indexOf(slides[galleryIndex]);
      if (n > -1) { e.preventDefault(); lbOpen(n); }
    });
  }

  /* ---- USP overlay: ambient, no controls — the active USP follows the
     gallery slide (image 1 → USP 1, image 2 → USP 2, …, cycling). ---- */
  var usp = section.querySelector('[data-usp]');
  if (usp) {
    var uspSlides = toArray(usp.querySelectorAll('[data-usp-slide]'));
    if (uspSlides.length) {
      uspSync = function (i) {
        var k = i % uspSlides.length;
        uspSlides.forEach(function (s, n) { s.classList.toggle('is-active', n === k); });
      };
      uspSync(galleryIndex);
      // Single-image products still surface all three: slow ambient rotate.
      if (slides.length <= 1 && uspSlides.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        var uspIdle = 0;
        setInterval(function () {
          uspIdle = (uspIdle + 1) % uspSlides.length;
          uspSlides.forEach(function (s, n) { s.classList.toggle('is-active', n === uspIdle); });
        }, 5000);
      }
    }
  }

  /* smooth scroll to reviews */
  section.querySelectorAll('[data-jdgm-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      // sections/reviews.liquid renders id="reviews"; the old product-reviews
      // section (and its id) is gone.
      var t = document.getElementById('reviews');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  update();

  /* Mobile sticky add-to-cart: submit the real form; reveal once the main CTA scrolls away */
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
    });
  }
  if (stickyBar && 'IntersectionObserver' in window) {
    var cta = section.querySelector('.pdp__cta');
    if (cta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stickyBar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(cta);
    }
  }

  /* Preload variant images so frame/size switches are instant (respects data saver).
     This used to fetch EVERY media on idle at page load — on a product with a
     dozen frame shots that is a dozen full-size images most shoppers never look
     at, competing with the LCP. Now it waits for the first touch of a variant
     control and only warms the media whose alt text matches an option the
     shopper has actually selected (frame colour, size); with no such match it
     falls back to the first three. Runs again on each change, deduped. */
  var preloaded = {};
  function preloadMedia() {
    if (navigator.connection && navigator.connection.saveData) return;
    var opts = selectedOptions();
    // The selected variant's own mockup first: most alts are Gelato UUIDs, so
    // the alt match below finds nothing on older products and the one image
    // the shopper is about to see would otherwise never be warmed.
    var v = findVariant(opts);
    var mid = v ? variantMedia[v.id] : null;
    var matches = media.filter(function (m) { return mid && m.id === mid; });
    matches = matches.concat(media.filter(function (m) {
      if (!m.url || !m.alt || m.id === mid) return false;
      var alt = String(m.alt).toLowerCase();
      return opts.some(function (o) {
        return o && alt.indexOf(String(o).toLowerCase()) > -1;
      });
    }));
    if (!matches.length) matches = media.slice(0, 3);
    matches.forEach(function (m) {
      if (!m.url || preloaded[m.url]) return;
      preloaded[m.url] = true;
      var img = new Image();
      img.src = m.url;
    });
  }
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-input]')) preloadMedia();
  });
})();
